import Notiflix from "notiflix";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Input,
  Layout,
  List,
  Modal,
  Row,
  Select,
  Spin,
  Switch,
  TimePicker,
  Typography,
} from "antd";
import { useNavigate } from "react-router-dom";

//PROJECT IMPORTS
import dayjs from "dayjs";
import "../../../assets/styles/DatePicker.css";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import timezones from "../../../config/data/timezones.json";
import { newGlAccountAction } from "../../../redux/actions";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../security.config";
import { encryptPayload } from "../../authentication/EncryptAuth";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const AddUser = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();
  const isAutoGeneratePassword = Form.useWatch("autoGeneratePassword", useForm);
  const accessDays = Form.useWatch("accessDays", useForm);
  const accessTime = Form.useWatch("accessTime", useForm);
  const isTemporary = Form.useWatch("isTemporary", useForm);
  const [officeData, setOfficeData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [timezonesData, setTimezonesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectStaffState, setSelectStaffState] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rolesList, setRolesList] = useState([]);

  const options = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  useEffect(() => {
    getTemplate();
  }, []);
  useEffect(() => {
    useForm.setFieldValue("passwordNeverExpires", false);
  }, []);

  function getTemplate() {
    const url = `${apiConfig.Users}/template`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempOffice = [];
        let tempRoles = [];
        let tempTimezones = [];

        objList?.allowedOffices?.forEach((element) => {
          tempOffice.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.availableRoles?.forEach((element) => {
          tempRoles.push({
            value: element.id.toString(),
            label: element.name,
            description: element.description,
          });
        });

        tempTimezones = timezones.map((tz) => ({
          label: tz.timezonename,
          value: tz.timezonename,
        }));

        setOfficeData(tempOffice);
        setRolesData(tempRoles);
        setTimezonesData(tempTimezones);
      }
    });
  }

  function getStaff(value) {
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      BOM.baseUrl("staff?officeId=" + value + "&status=all"),
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err);
        } else {
          const objList = res;
          let tempStaff = [];

          objList?.forEach((element) => {
            tempStaff.push({
              value: element.id,
              label: element.displayName,
            });
          });

          setStaffData(tempStaff);

          setSelectStaffState(false);
        }
      },
    );
  }

  function onCancel() {
    navigate("/sms0100", { replace: false });
  }

  const handleRoleDelete = (key) => {
    let action = "Delete  ";
    let label = key.title;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = rolesList.filter((item) => item.id !== key.id);
        setRolesList(newData);
      },

      function () {
        // No button
      },
    );
  };

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Users}`;

    const { autoGeneratePassword, ...filteredFormValues } = formValues;

    filteredFormValues.roles = rolesList.map((role) => `${role.id}`);
    filteredFormValues.sendPasswordToEmail = formValues.autoGeneratePassword;
    filteredFormValues.startDate = filteredFormValues.startDate
      ? BOM.DateTime(filteredFormValues.startDate, "only-date")
      : filteredFormValues.startDate;
    filteredFormValues.expiryDate = filteredFormValues.expiryDate
      ? BOM.DateTime(filteredFormValues.expiryDate, "only-date")
      : filteredFormValues.expiryDate;
    filteredFormValues.loginTimeFrom =
      filteredFormValues?.loginTimeFrom?.format("HH:mm");
    filteredFormValues.loginTimeTo =
      filteredFormValues?.loginTimeTo?.format("HH:mm");

    if (filteredFormValues.password) {
      filteredFormValues.password = encryptPayload(filteredFormValues.password);
    }
    if (filteredFormValues.repeatPassword) {
      filteredFormValues.repeatPassword = encryptPayload(
        filteredFormValues.repeatPassword,
      );
    }

    const body = {
      ...filteredFormValues,
      method: "POST",
      session,
    };
    // console.log(body);
    // return;

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newUserMsg);
          navigate("/sms0100");
          // STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/sms0100");
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newUser}
        pageItems={staticConfig.newUserBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Form
          layout="vertical"
          onFinish={onSubmit}
          initialValues={{
            autoGeneratePassword: true,
          }}
          form={useForm}
        >
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="username"
                    label={<Text strong>{labelConfig.userName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                      {
                        min: 5,
                        message: "Please enter more than 5 characters.",
                      },
                    ]}
                  >
                    <Input placeholder="Enter username" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="firstname"
                    label={<Text strong>{labelConfig.firstName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Input placeholder="Enter first name" />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="lastname"
                    label={<Text strong>{labelConfig.lastName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Input placeholder="Enter last name" />
                  </Form.Item>
                </Col>
                <div style={{ width: "15vh" }}></div>
              </Row>

              <Row>
                {" "}
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="email"
                    label={<Text strong>{labelConfig.email}</Text>}
                    rules={BOM.fieldRules("email", true)}
                  >
                    <Input placeholder="example@gmail.com" />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="autoGeneratePassword"
                    label={
                      <Text strong>
                        {labelConfig.manageUsersAutoGeneratePassword}
                      </Text>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Please select an option"
                      showSearch
                      options={staticConfig.yesOrNoData}
                      // onSelect={(value) => autoGeneratePasswordFunc(value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="passwordNeverExpires"
                    label={
                      <Text strong>
                        {labelConfig.manageUsersOverridePassword}
                      </Text>
                    }
                  >
                    <Select
                      disabled
                      placeholder="Please select an option"
                      showSearch
                      options={staticConfig.yesOrNoData}
                    />
                  </Form.Item>
                </Col>
                {!isAutoGeneratePassword && (
                  <>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text strong>{labelConfig.password}</Text>}
                        name="password"
                        rules={BOM.fieldRules("strong-password", true)}
                      >
                        <Input.Password
                          className="of-bold-disable-input"
                          placeholder="Please enter a Password"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={
                          <Text strong>{labelConfig.confirmPassword}</Text>
                        }
                        name="repeatPassword"
                        rules={BOM.fieldRules("strong-password", true)}
                      >
                        <Input.Password
                          className="of-bold-disable-input"
                          placeholder="Please enter a Password"
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="officeId"
                    label={<Text strong>{labelConfig.branch}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Please select an office"
                      showSearch
                      options={officeData}
                      onSelect={(value) => getStaff(value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="staffId"
                    label={<Text strong>{labelConfig.manageUsersStaff}</Text>}
                    rules={[
                      {
                        required: false,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      disabled={selectStaffState}
                      placeholder="Please select staff"
                      showSearch
                      options={staffData}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <div style={{ width: "15vh" }}></div>
              </Row>
              <Row>
                <div
                  style={{
                    width: "100%",
                    padding: "16px",
                  }}
                >
                  <Spin spinning={isLoading} tip="Loading..." size="large">
                    <Divider orientation="left" orientationMargin="0">
                      <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                        {"Manage Roles"}
                      </Title>
                    </Divider>

                    <RolesModal
                      isModalOpen={isModalOpen}
                      setIsModalOpen={setIsModalOpen}
                      setRolesList={setRolesList}
                      rolesList={rolesList}
                      rolesData={rolesData}
                    />
                    {rolesList?.length > 0 && (
                      <List
                        itemLayout="horizontal"
                        dataSource={rolesList}
                        renderItem={(item, index) => (
                          <Card style={{ width: "100%", marginBottom: 20 }}>
                            <List.Item
                              actions={[
                                <Button
                                  type="primary"
                                  danger
                                  shape="round"
                                  size="small"
                                  onClick={() => handleRoleDelete(item)}
                                  icon={<DeleteOutlined />}
                                  style={{
                                    boxShadow:
                                      "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    marginLeft: "auto",
                                  }}
                                >
                                  Remove
                                </Button>,
                              ]}
                            >
                              <List.Item.Meta
                                title={item.title}
                                description={item.description}
                              />
                            </List.Item>
                          </Card>
                        )}
                      />
                    )}
                  </Spin>
                </div>
              </Row>

              <Row>
                <div
                  style={{
                    width: "100%",
                    padding: "16px",
                  }}
                >
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                      {"User Access Control"}
                    </Title>
                  </Divider>

                  <Row>
                    {/* <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="accessDays"
                        label={
                          <Text strong>
                            {labelConfig.manageUsersAccessDays}
                          </Text>
                        }
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "Required Field",
                        //   },
                        // ]}
                      >
                        <Select
                          // disabled
                          placeholder="Please select an option"
                          options={[
                            "Default workdays",
                            "Everyday (Sun - Sat)",
                            "Custom days",
                          ].map((opt) => ({
                            label: opt,
                            value: opt,
                          }))}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="accessTime"
                        label={
                          <Text strong>
                            {labelConfig.manageUsersAccessTime}
                          </Text>
                        }
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "Required Field",
                        //   },
                        // ]}
                      >
                        <Select
                          // disabled
                          placeholder="Please select an option"
                          options={[
                            "Default work hours",
                            "24 hours access",
                            "Custom time",
                          ].map((opt) => ({
                            label: opt,
                            value: opt,
                          }))}
                        />
                      </Form.Item>
                    </Col>

                    {accessDays === "Custom days" && (
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          name="allowAccess"
                          label={
                            <Text strong>
                              {labelConfig.manageUsersAllowAccess}
                            </Text>
                          }
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Required Field",
                          //   },
                          // ]}
                        >
                          <Select
                            mode="multiple"
                            showSearch
                            placeholder="Select Options"
                            options={[
                              "Monday",
                              "Tuesday",
                              "Wednesday",
                              "Thursday",
                              "Friday",
                              "Saturday",
                              "Sunday",
                            ].map((day) => ({
                              label: day,
                              value: day,
                            }))}
                          />
                        </Form.Item>
                      </Col>
                    )} */}
                  </Row>

                  <Row>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="loginTimeFrom"
                        label={
                          <Text strong>{labelConfig.manageUsersStartTime}</Text>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <TimePicker
                          style={{ width: "100%" }}
                          format="HH:mm"
                          showSecond={false}
                          defaultOpenValue={dayjs("00:00", "HH:mm")}
                          popupClassName="custom-timepicker-dropdown"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="loginTimeTo"
                        label={
                          <Text strong>{labelConfig.manageUsersEndTime}</Text>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <TimePicker
                          style={{ width: "100%" }}
                          format="HH:mm"
                          showSecond={false}
                          defaultOpenValue={dayjs("00:00", "HH:mm")}
                          popupClassName="custom-timepicker-dropdown"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="loginTimezone"
                        label={
                          <Text strong>{labelConfig.manageUsersTimezone}</Text>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Please select an option"
                          options={timezonesData}
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      span={8}
                      style={{
                        padding: "0px 8px",
                        marginBottom: 20,
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <Form.Item
                        name="isTemporary"
                        valuePropName="checked"
                        initialValue={false}
                        style={{ marginBottom: 0 }}
                      >
                        <Switch
                          style={{
                            backgroundColor: isTemporary
                              ? "#92428B"
                              : "#F2F4F7",
                          }}
                        />
                      </Form.Item>
                      <Text style={{ marginLeft: 5, marginRight: 10 }}>
                        {labelConfig.manageUsersTemporaryUser}
                      </Text>
                    </Col>
                  </Row>

                  {isTemporary && (
                    <Row>
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          name="startDate"
                          label={
                            <Text strong>
                              {labelConfig.manageUsersStartDate}
                            </Text>
                          }
                          rules={[
                            {
                              required: true,
                              message: "Required Field",
                            },
                          ]}
                        >
                          <DatePicker
                            disabledDate={BOM.DisableBeforeCurrentDate}
                            placeholder={BOM.handlePlaceholderMsg(
                              `${labelConfig.fromDate}`,
                              "select",
                            )}
                            style={{
                              marginBottom: 0,
                              width: "100%",
                              height: 35,
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          name="expiryDate"
                          label={
                            <Text strong>{labelConfig.manageUsersEndDate}</Text>
                          }
                          rules={[
                            {
                              required: true,
                              message: "Required Field",
                            },
                          ]}
                        >
                          <DatePicker
                            disabledDate={BOM.DisableBeforeCurrentDate}
                            placeholder={BOM.handlePlaceholderMsg(
                              `${labelConfig.toDate}`,
                              "select",
                            )}
                            style={{
                              marginBottom: 0,
                              width: "100%",
                              height: 35,
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                </div>
              </Row>

              <Row style={{ justifyContent: "space-between" }}></Row>
            </Card>

            <Form.Item>
              <Row>
                {BOM.HasPermission("CREATE_USER") && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    htmlType="submit"
                    backgroundColor="#15CCAE"
                    colorText="black"
                    hoverBackground="#4FECA0"
                  />
                )}
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Card>
        </Form>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { newGlAccountAction };

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);

export const RolesModal = (props) => {
  const { isModalOpen, setIsModalOpen, setRolesList, rolesList, rolesData } =
    props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleRoleSave = (formValues) => {
    const role = rolesData.find((item) => item.value === formValues.roles);

    const newRoles = {
      id: parseInt(formValues.roles, 10),
      title: role?.label,
      description: role?.description,
    };

    if (rolesList.some((role) => role.id === newRoles?.id)) {
      useForm.resetFields();
    } else {
      setRolesList([...rolesList, newRoles]);
      useForm.resetFields();
    }
  };

  return (
    <Row>
      {BOM.HasPermission("CREATE_ROLE") && (
        <Button
          type="primary"
          className="of-primaryBtnColor"
          onClick={showModal}
          icon={<PlusCircleOutlined />}
          shape="round"
          style={{
            marginBottom: 20,
          }}
        >
          Add
        </Button>
      )}

      <Modal
        title="Add User Role(s)"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={1000}
      >
        <Form
          form={useForm}
          layout="vertical"
          onFinish={handleRoleSave}
          name="roles"
        >
          <Divider />

          <Row>
            <div
              style={{
                width: 800,
                padding: "16px",
              }}
            >
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={"Available Roles"}
                  name={"roles"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld("Role"),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase(),
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg("Role", "select")}
                    options={rolesData}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </div>
          </Row>

          <Row>
            <Divider />
            <CustomButton
              content="Save"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              htmlType="submit"
              backgroundColor="#15CCAE"
              colorText="black"
              hoverBackground="#4FECA0"
            />

            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </Row>
  );
};
